import FolderIcon from "@mui/icons-material/Folder";
import BackupTableIcon from "@mui/icons-material/BackupTable";
import AssignmentIcon from "@mui/icons-material/Assignment";
import ChatIcon from "@mui/icons-material/Chat";
import ImageIcon from "@mui/icons-material/Image";
import LinkIcon from "@mui/icons-material/Link";
import StorageIcon from "@mui/icons-material/Storage";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import SmartDisplayIcon from "@mui/icons-material/SmartDisplay";
import { FileText, ClipboardCheck, MessageCircleMore, MessageSquareWarning, FileDown, ClipboardPen, ExternalLink, Puzzle, Folder } from "lucide-react";
import meet from "../assets/online/meet.png";
import teams from "../assets/online/teams.png";
import zoom from "../assets/online/zoom.png";



export const IconsComponent = ({ resource, color }) => {
  let styles = {

    // marginRight: "10px",
    fontSize: 24,
    color:color,
    opacity:.75
  };

  const lucideStyle = { size: 22, color, opacity: 0.75, strokeWidth: 1.75 };
  
  const ICONS  = {
    forum: <MessageCircleMore {...lucideStyle} />,
    pdf: <FileDown {...lucideStyle} />,
    choice: <ClipboardCheck {...lucideStyle} />,
    feedback: <MessageSquareWarning {...lucideStyle} />,
    scorm: <BackupTableIcon sx={styles} />,
    assign: <ClipboardPen {...lucideStyle} />,
    folder: <Folder {...lucideStyle} />,
    chat: <ChatIcon sx={styles} />,
    page: <FileText {...lucideStyle} />,
    png: <ImageIcon sx={styles} />,
    quiz: <ClipboardCheck {...lucideStyle} />,
    url: <ExternalLink {...lucideStyle} />,
    data: <StorageIcon sx={styles} />,
    customcert: <WorkspacePremiumIcon sx={styles} />,
    vimeo: <SmartDisplayIcon sx={styles} />,
    h5pactivity: <Puzzle {...lucideStyle} />,
    hvp: <Puzzle {...lucideStyle} />,
    meet: <img alt="Meet" src={meet} width="18px" />,
    teams: <img alt="Teams" src={teams} width="18px" />,
    zoom: <img alt="Zoom" src={zoom} width="18px" />,
  };
  return ICONS[resource];

}
